/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPotteryPaintingWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPotteryPaintingWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Get Creative with Pottery!",
    "Pottery Painting Workshop Awaits!",
    "Craft and Paint Together!",
  ],
  title: "Pottery Painting Workshop",
  description: "Organize a fun pottery painting workshop.",
  longDescription:
    "Gather your friends for an exciting pottery painting workshop! Choose a date, decide on pottery items to paint, and plan refreshments!",
  emoji: "🎨",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Pottery Painting Workshop",
          emoji: "🎨",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the pottery painting workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on pottery items to paint?",
            description:
              "What pottery items should we focus on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What pottery items should we consider?",
                emoji: "🖌",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we plan for the workshop?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍵",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Crafty with Pottery!",
    outroDescription:
      "Your pottery painting workshop plans are set! Enjoy the creativity!",
  },
};
